import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { OutputConfigSlice } from "../../redux";
import { useUser } from "../../../../../AuthContext";
import { OutputConfigListView } from "./OutputConfigList.View";
import { FetchOutputConfigList } from "./Script";
import { PopulateConfigListTable } from "./Helper";

/**
 * Responsible for rendering the list of the output configuration
 * @returns JSX element
 */
export const OutputConfigList: React.FC = (): JSX.Element => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const [
    extractState,
    outputConfig
  ] = useSelector((state: IRootState) => [
    state.extractState,
    state.outputConfig
  ], shallowEqual);
  const selectedExtract = extractState.selectedExtract;
  const extractGuid = selectedExtract?.extractGuid as string;
  const configurationList = outputConfig?.configList;
  const { user } = useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  useEffect(() => {
    FetchOutputConfigList(dispatch, translate, extractGuid, env, user?.token);
  }, [extractGuid]);

  useEffect(() => {
    return (): void => {
      dispatch(OutputConfigSlice.actions.setConfigList(
        PopulateConfigListTable("", dispatch, true)
      ));
    };
  }, []);

  return (
    <div>
      <OutputConfigListView data={configurationList} />
    </div>
  );
};
